/* NAKR V440 — accessible LAAGAM-inspired product tabs.
   Progressive enhancement: native details accordions remain usable without JS. */
(() => {
  const activate = (panels, buttons, index, focus) => {
    panels.forEach((panel, i) => {
      const current = i === index;
      panel.classList.toggle('nakr-v440-panel-active', current);
      panel.setAttribute('aria-hidden', String(!current));
      panel.tabIndex = current ? 0 : -1;
      const details = panel.querySelector('details');
      if (details) details.open = current;
      const btn = buttons[i];
      btn.setAttribute('aria-selected', String(current));
      btn.tabIndex = current ? 0 : -1;
    });
    if (focus) buttons[index].focus();
  };
  const init = (scope = document) => {
    scope.querySelectorAll('product-info[id^="MainProduct-"] .product__info-container').forEach((container) => {
      if (container.dataset.nakrV440Tabs === 'ready') return;
      const panels = Array.from(container.children).filter((el) => el.classList.contains('product__accordion') && el.querySelector('details'));
      if (panels.length < 2) return;
      const tabs = document.createElement('div');
      tabs.className = 'nakr-v440-tablist';
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', 'Informations sur le produit');
      const buttons = panels.map((panel, index) => {
        const name = panel.querySelector('.accordion__title')?.textContent?.trim() || `Informations ${index + 1}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'nakr-v440-tab';
        button.textContent = name;
        button.id = `nakr-v440-tab-${container.id || 'product'}-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', `nakr-v440-panel-${container.id || 'product'}-${index}`);
        panel.classList.add('nakr-v440-tab-panel');
        panel.id = `nakr-v440-panel-${container.id || 'product'}-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        button.addEventListener('click', () => activate(panels, buttons, index, false));
        button.addEventListener('keydown', (event) => {
          let target = null;
          if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') target = (index + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = buttons.length - 1;
          if (target !== null) { event.preventDefault(); activate(panels, buttons, target, true); }
        });
        tabs.appendChild(button);
        return button;
      });
      panels[0].before(tabs);
      container.dataset.nakrV440Tabs = 'ready';
      activate(panels, buttons, 0, false);
      document.addEventListener('shopify:block:select', (event) => {
        const idx = panels.findIndex((panel) => panel.contains(event.target) || panel === event.target);
        if (idx >= 0) activate(panels, buttons, idx, false);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
